<template>
	<app>
		<crumb-bar></crumb-bar>
		<menu-aside>
			<m-operate>
				<c-button icon="add" @click="addProject()">加入项目</c-button>
			</m-operate>
			
			<c-table ref="table">
				<c-table-column
					label="项目编号"
					name="code"
					width="200"
				></c-table-column>
				
				<c-table-column
					label="项目名称"
					name="name"
					width="300"
				></c-table-column>
				
				<c-table-column
					label="施工(中标)单位"
					name="zbqy_name"
					width="300"
				></c-table-column>
				
				<c-table-column
					type="button"
					label="操作"
					width="100"
				>
					<template v-slot="{data}">
						<c-table-button @click="navigateTo('/transact/project/detail', {id: data.id}, true)">详情</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</menu-aside>
		
		<c-dialog ref="addProject" title="加入项目" width="750" button-name="确定加入" @resolve="addProjectHandle">
			<c-hint>手动加入项目时，项目邀请码请向中标企业单位咨询</c-hint>
			<c-form ref="addProjectForm" unit-width="400">
				<c-form-item v-model="inputCode" type="input" label="项目邀请码" required @change="getProjectInfo"></c-form-item>
				<c-form-item type="input" label="项目名称" name="name" required disabled></c-form-item>
				<c-form-item type="input" label="中标单位" name="zbqy_name" required disabled></c-form-item>
			</c-form>
		</c-dialog>
	</app>
</template>

<script>
	export default {
		data() {
			return {
				inputCode: '',
				inviteCode: ''
			}
		},
		
		mounted() {
			this.updateList();
		},
		
		methods: {
			updateList() {
				this.$refs.table.load({
					url: '/project/list'
				});
			},
			
			addProject() {
				this.$refs.addProjectForm.clear();
				this.$refs.addProject.open();
			},
			
			getProjectInfo() {
				if (this.inputCode) {
					this.request({
						url: '/project/queryByCode',
						data: {
							yq_code: this.inputCode
						},
						success: data => {
							this.inviteCode = this.inputCode;
							this.$refs.addProjectForm.set(data);
						},
						fail: () => {
							this.inviteCode = '';
							this.$refs.addProjectForm.clear();
						}
					});
				} else {
					this.inviteCode = '';
					this.$refs.addProjectForm.clear();
				}
			},
			
			addProjectHandle(stop, next) {
				stop();
				if (!this.inviteCode) {
					this.$message({
						text: '请填写项目邀请码'
					});
					return;
				}
				
				this.request({
					url: '/project/bind_jl',
					data: {
						yq_code: this.inviteCode
					},
					loading: true,
					success: data => {
						next();
						this.$message({
							text: '添加成功'
						});
						this.$refs.table.update(1);
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
